import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChefHat } from "lucide-react";
import CheckoutModal from "@/components/CheckoutModal";
import { sendPixelEvent } from "@/lib/pixelXApp";

interface HeaderProps {
  hideCheckoutButton?: boolean;
}

const Header = ({ hideCheckoutButton = false }: HeaderProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleCheckout = async () => {
    await sendPixelEvent('AddToCart');
    setModalOpen(true);
  };

  return (
    <header className="relative lg:sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-2">
          <ChefHat className="h-6 w-6 text-primary" />
          <span className="font-bold text-lg">30 Receitas Express</span>
        </div>
        {!hideCheckoutButton && (
          <Button 
            onClick={handleCheckout}
            size="sm"
            className="bg-gradient-warm hover:shadow-hover transition-all duration-300"
          >
            Comprar por R$ 29,90
          </Button>
        )}
      </div>
      
      <CheckoutModal open={modalOpen} onOpenChange={setModalOpen} />
    </header>
  );
};

export default Header;
